import React, { useState } from 'react';

const steps = [
  { title: 'Добро пожаловать в Khepri!', text: 'Ваш ИИ-помощник для малого и среднего бизнеса в России.' },
  { title: 'Подключите банк', text: 'Перейдите в Настройки, чтобы подключить Сбер или Точку для реальных транзакций.' },
  { title: 'Проверьте главный экран', text: 'Каждое утро видите баланс, налоги и 3 ключевые задачи от ИИ.' },
];

function Onboarding({ onDone }) {
  const [step, setStep] = useState(0);

  return (
    <div style={{ textAlign: 'center', padding: 40, background: '#1E293B', borderRadius: 12, maxWidth: 400, margin: '40px auto' }}>
      <div style={{ fontSize: 40, marginBottom: 16 }}>{step === 0 ? '🪲' : step === 1 ? '🏦' : '📋'}</div>
      <h2>{steps[step].title}</h2>
      <p style={{ color: '#94A3B8', marginTop: 12, marginBottom: 24 }}>{steps[step].text}</p>
      <div style={{ display: 'flex', gap: 8, justifyContent: 'center' }}>
        {step > 0 && (
          <button onClick={() => setStep(step - 1)} style={{ padding: '10px 24px', background: '#334155', color: '#F8FAFC', border: 'none', borderRadius: 8, cursor: 'pointer' }}>Назад</button>
        )}
        {step < 2 ? (
          <button onClick={() => setStep(step + 1)} style={{ padding: '10px 24px', background: '#6366F1', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer' }}>Далее</button>
        ) : (
          <button onClick={onDone} style={{ padding: '10px 24px', background: '#10B981', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer' }}>Перейти к главному экрану</button>
        )}
      </div>
      <div style={{ marginTop: 16, display: 'flex', gap: 6, justifyContent: 'center' }}>
        {steps.map((_, i) => (
          <div key={i} style={{ width: 8, height: 8, borderRadius: '50%', background: i === step ? '#6366F1' : '#334155' }} />
        ))}
      </div>
    </div>
  );
}

export default Onboarding;